export default function(h, row, index) {
    let _s1 =  row.surname + ' ' + row.name_ + ' ' + row.patro;

    if (row.company_main_id)
        return <span class="alert-danger">{_s1}</span>
    else
        return <span>{_s1}</span>

}
